import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=6556b5b2&scoped=true"
import script from "./pages.vue?vue&type=script&lang=js"
export * from "./pages.vue?vue&type=script&lang=js"
import style0 from "./pages.vue?vue&type=style&index=0&id=6556b5b2&prod&lang=scss"
import style1 from "./pages.vue?vue&type=style&index=1&id=6556b5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6556b5b2",
  null
  
)

export default component.exports